module.exports = __webpack_public_path__ + "static/slider-perks-img5-5c900edf60a35d10f8afdc1df5d3c89a.jpeg";